import { render } from "./DownloadIcon.vue?vue&type=template&id=749bc8c5&bindings={}"
import script from "./DownloadIcon.vue?vue&type=script&lang=ts"
export * from "./DownloadIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script